import { differenceInMinutes } from "date-fns";

export const isFromLastXHours = (date: string, hours: number): boolean => {
  const hoursToMinutes = hours * 60;
  const now = new Date();
  const minutesDifference = differenceInMinutes(now, new Date(date));
  return minutesDifference <= hoursToMinutes;
};
